import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const session = localStorage.getItem('mines_session');
    if (session) {
      try {
        const sessionData = JSON.parse(session);
        if (sessionData.userId && sessionData.username) {
          setUser({ id: sessionData.userId, username: sessionData.username });
          setProfile({
            id: sessionData.userId,
            username: sessionData.username,
            balance: sessionData.balance || 0,
            verified: true,
          });
        }
      } catch (e) {
        localStorage.removeItem('mines_session');
      }
    }
    setLoading(false);
  }, []);

  function updateSession(sessionData) {
    if (!sessionData || !sessionData.userId) return;
    localStorage.setItem('mines_session', JSON.stringify(sessionData));
    setUser({ id: sessionData.userId, username: sessionData.username });
    setProfile({
      id: sessionData.userId,
      username: sessionData.username,
      balance: sessionData.balance || 0,
      verified: true,
    });
  }

  async function refreshProfile() {
    const session = localStorage.getItem('mines_session');
    if (session) {
      try {
        const sessionData = JSON.parse(session);
        setProfile({
          id: sessionData.userId,
          username: sessionData.username,
          balance: sessionData.balance || 0,
          verified: true,
        });
      } catch (e) {}
    }
  }

  async function signIn(robloxUsername) {
    return true;
  }

  async function signUp(robloxUsername) {
    return true;
  }

  async function verifySignup(username) {
    return true;
  }

  async function signOut() {
    localStorage.removeItem('mines_session');
    setUser(null);
    setProfile(null);
  }

  return (
    <AuthContext.Provider value={{ user, profile, loading, signUp, signIn, signOut, refreshProfile, verifySignup, updateSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
